import { render, staticRenderFns } from "./Accueil_Nouvelles.vue?vue&type=template&id=37fea6ea&"
import script from "./Accueil_Nouvelles.vue?vue&type=script&lang=js&"
export * from "./Accueil_Nouvelles.vue?vue&type=script&lang=js&"
import style0 from "./Accueil_Nouvelles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports